.leftColumn {
    /* border-box: 200 plus the 12px of right padding */
    width: 212px;
    padding-right: 12px;
}

.leftBlock {
    margin-bottom: 15px;
}

.leftBlockTitle {
    padding: 4px 10px 4px 22px;
    background: url(./assets/images/theme/left_title.jpg) top left no-repeat;
    font-size: 14px;
    color: #fff;
}

.leftBlockContent {
    padding: 10px 5px 20px;
    /* border-box: 190 plus the 5px of padding per side */
    width: 200px;
    background: #cae5ff url(./assets/images/theme/left_back.jpg) top left repeat-x;
    font-size: 70%;
    line-height: 120%;
    color: #666;
}

.leftBlockContent a {
    font-weight: bold;
    color: #0000ff;
}

.leftBlockContent a:hover {
    color: #ff6600;
}

/* sanitize.css forms.css leaves form controls transparent and makes them
   inherit the block's 70% text; keep them on white at the control size. */
.leftBlockContent input[type="text"],
.leftBlockContent select,
.leftBlockContent button,
.leftBlockContent :global(.formButton) {
    background-color: #ffffff;
    color: #000000;
    font-size: 13.3333px;
}
